import React from 'react';

import Tabs from '../../components/Tab';
import {
    Cotainer
} from '../../components/AppWrapper';
import DepositHistory from './Deposit';

import { DescriptionWrapper } from './style';


const History = () => {
    const renderTabBar = (props, DefaultTabBar) => {
        return (
            <DefaultTabBar {...props} />
        );
    };

    const HistoryTabList = [
        {
            key: 'deposits',
            name: 'Deposits',
            content: <DepositHistory type='deposit' />
        },
        {
            key: 'withdrawals',
            name: 'Withdrawals',
            content: <DepositHistory type='withdraw'/>
        }
    ];

    return (
        <Cotainer>
            <DescriptionWrapper>
                <div className="history-title">
                    <h2>
                        <b>Wallet history</b>
                    </h2>
                </div>
                <Tabs
                    TabList={HistoryTabList}
                    renderTabBar={renderTabBar}
                />
            </DescriptionWrapper>
        </Cotainer>
    );
}

export default History;
